import "./styles/app.css";
import "./styles/k01.css";
import { K01App } from "./app/k01/k01-app";
import { registerServiceWorker } from "./pwa/register-service-worker";

const root = document.querySelector<HTMLElement>("#app");

if (!root) {
  throw new Error("Appens rot-element saknas.");
}

new K01App(root).start();
registerServiceWorker();
